export var ODataOperator;
(function (ODataOperator) {
    ODataOperator["Equals"] = "eq";
    ODataOperator["NotEquals"] = "ne";
    ODataOperator["GreaterThan"] = "gt";
    ODataOperator["GreaterThanOrEquals"] = "ge";
    ODataOperator["LessThan"] = "lt";
    ODataOperator["LessThanOrEquals"] = "le";
    ODataOperator["And"] = "and";
    ODataOperator["Or"] = "or";
    ODataOperator["Not"] = "not";
    ODataOperator["Add"] = "add";
    ODataOperator["Sub"] = "sub";
    ODataOperator["Mul"] = "mul";
    ODataOperator["Div"] = "div";
    ODataOperator["Mod"] = "mod";
})(ODataOperator || (ODataOperator = {}));
export var ODataFunction;
(function (ODataFunction) {
    ODataFunction["Substringof"] = "substringof";
    ODataFunction["Contains"] = "substringof";
    ODataFunction["StartsWith"] = "startswith";
    ODataFunction["NotContains"] = "not substringof";
})(ODataFunction || (ODataFunction = {}));
export const buildComparisonOData = (oDataFunction, property, value) => {
    let params = '';
    switch (oDataFunction) {
        case ODataFunction.Contains:
        case ODataFunction.NotContains:
        case ODataFunction.Substringof:
            params = `'${value}',${property}`;
            break;
        case ODataFunction.StartsWith:
            params = `${property},'${value}'`;
            break;
    }
    return `${oDataFunction}(${params})`;
};
export const matchODataFunction = (s) => Object.values(ODataFunction).includes(s);
